import { render, staticRenderFns } from "./ChangeUserDataView.vue?vue&type=template&id=c74d83fc&scoped=true&"
import script from "./ChangeUserDataView.vue?vue&type=script&lang=js&"
export * from "./ChangeUserDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74d83fc",
  null
  
)

export default component.exports